import JsonUsername from "./data/username.json";
var UserHandler = /** @class */ (function () {
    function UserHandler() {
        this.username_list = JsonUsername;
    }
    UserHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new UserHandler();
        }
        return this._instance;
    };
    UserHandler.prototype.load = function () {
        this.user = this.generate_user();
    };
    UserHandler.prototype.generate_user = function () {
        var l = this.username_list.length; // length
        var i = Math.round(Math.random() * (l - 1)); // index
        var m = Math.round(Math.random() * 1000); // mutation
        var u = this.username_list[i]; // random username
        var p = Math.round(Math.random() * 19); // profile picture
        var username = "".concat(u, "-").concat(m);
        var user = {
            id: username,
            username: username,
            picture: p,
        };
        return user;
    };
    return UserHandler;
}());
export default UserHandler;
